<div
  class="flex h-full flex-col border bg-white p-2 shadow-sm"
  [style.min-width]="width +'px'"
>
  <ul
    role="listbox"
    [ariaLabel]="id+' select'"
    aria-orientation="vertical"
    [attr.data-testid]="uncontrolledSelectList"
  >
    @if(options && options.length === 0){
    <pax-uncontrolled-select-list-option
      [id]="getOptionId('empty')"
      [option]="emptyOption"
    />
    } @for (option of options; track option.value) {
    <pax-uncontrolled-select-list-option
      [id]="getOptionId(option.value)"
      [option]="option"
      [disabled]="!!option.disabled"
      [selectedValue]="selectedValue"
      (clicked)="clicked.emit($event)"
    />
    }
  </ul>
</div>
